import aiProjection from './icons/ai_projection.svg';
import analysis from './icons/analysis.svg';
import construction from './icons/construction.svg';
import electricBolt from './icons/electric_bolt.svg';
import lightbulb from './icons/lightbulb.svg';
import searchInsights from './icons/search_insights.svg';
import timer from './icons/timer.svg';
import styles from './IconListSection.module.css';

const iconMap = {
  ai_projection: aiProjection,
  analysis,
  construction,
  electric_bolt: electricBolt,
  lightbulb,
  search_insights: searchInsights,
  timer,
};

export type IconItem = {
  icon: keyof typeof iconMap;
  oneLineText: string;
  subheading: string;
};

export type IconListSectionProps = {
  blockIconList?: IconItem[] | null;
  heading?: string;
};

export const IconListSection = ({ blockIconList, heading }: IconListSectionProps) => {
  const items = blockIconList ?? [];
  return (
    <section className={styles.section}>
      {heading && <h2 className={styles.heading}>{heading}</h2>}
      {items.length > 0 && (
        <ul className={styles.list}>
          {items.map(({ icon, oneLineText, subheading }) => (
            <li className={styles.item} key={`${icon}-${subheading}`}>
              {iconMap[icon] && <img alt="" className={styles.icon} src={iconMap[icon]} />}
              <div className={styles.content}>
                <strong className={styles.subheading}>{subheading}</strong>
                <p className={styles.text}>{oneLineText}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
